module.exports = __webpack_public_path__ + "img/mena-vimto.57a22158.svg";